/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import dayjs from 'dayjs'
import qs from 'qs'
import { Button, Table, Breadcrumb, Divider, Switch } from 'antd'
import { withQuery } from '@/utils'
import * as actions from '@/models/bonusCoupon/actions'
import * as selectors from '@/models/bonusCoupon/selectors'
import * as couponAction from '@/models/coupons/actions'
import styles from './bonusCoupon.module.scss'
import * as apis from '@/apis';
import BonusCouponDialog from '@/components/dialogs/BonusCouponDialog'

function getColumns({ fetch, showCouponStatsDialog, upateCouponStatus }) {
  const dispatch = useDispatch()

  const showEditBonusCouponDialog = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showBonusCouponDialog({
      coupon: item,
      title: '编辑',
      ismodify: "modify",
      submitCallback: () => { fetch() }
    }))
  })

  const deleteBonusCoupon = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.deleteBonusCoupon(item._id, fetch))
  })
  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '名称',
      render: item => (
        <div>
          <div>{item.name}</div>
        </div>
      )
    },
    {
      title: '类型',
      render: item => (
        <div>
          <div>{item.couponType == 1 ? '注册奖励' : '完单奖励'}</div>
        </div>
      )
    },
    {
      title: '状态',
      render: item => (
        <div>
          <div>
            <Switch checked={item.status == 1} onChange={upateCouponStatus.bind(this, item)} /></div>
        </div>
      )
    },
    {
      title: '开始日期',
      render: item => (
        <div>
          {item.fromTime ? dayjs(item.fromTime).format('YYYY-MM-DD') : '-'}
        </div>
      )
    },
    {
      title: '截止日期',
      render: item => (
        <div>
          {item.toTime ? dayjs(item.toTime).format('YYYY-MM-DD') : '-'}
        </div>
      )
    },
    {
      title: '完单数量要求',
      render: item => (
        <div>
          <div>{item.couponType == 1 ? "-" : item.orders}</div>
        </div>
      )
    },
    {
      title: '奖金券有效期',
      render: item => (
        <div>
          <div>{item.expiration}</div>
        </div>
      )
    },
    {
      title: '奖金券金额(元)',
      render: item => (
        <div>
          <div>{item.coupons}</div>
        </div>
      )
    },
    {
      title: '奖金券数量',
      render: item => (
        <div>
          <div>{item.amount}</div>
        </div>
      )
    },
    {
      title: '可领取次数',
      render: item => (
        <div>
          <div>{item.couponType == 2 ? (item.times ? item.times : '无限制') : '-'}</div>
        </div>
      )
    },
    {
      title: '超额叠加',
      render: item => (
        <div>
          <div>{item.couponType == 2 ? (item.cumulative ? '是' : '否') : '-'}</div>
        </div>
      )
    },
    {
      title: '描述',
      render: item => (
        <div>
          <div>{item.memo}</div>
        </div>
      )
    },
    {
      title: '创建时间',
      render: item => (
        <div>
          {item.createdAt ? dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
        </div>
      )
    },
    {
      title: '操作',
      render: item => {
        return (
          <div>
            <a onClick={showEditBonusCouponDialog(item)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={deleteBonusCoupon(item)}>删除</a>
            <Divider type="vertical" />
            <a onClick={showCouponStatsDialog(item)}>统计</a>
          </div>
        )
      }
    }
  ]
}

function BonusCouponList(props) {
  const dispatch = useDispatch()
  const { query, history, match, location } = props
  const prevQuery = usePrevious(query)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const bonusCoupons = useSelector(selectors.entriesSelectors)
  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }
  const fetch = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setQueryParams(params)
    dispatch(actions.fetchList(params))
  }, [])
  const showInfoDialog = useCallback((title) => () => {
    dispatch(actions.showBonusCouponDialog({
      title,
      mgroups: {},
      submitCallback: () => { fetch(query) }
    }))
  }, [query])
  const showCouponStatsDialog = useCallback(bonus => () => {
    dispatch(couponAction.showCouponStatsDialog({
      title: `${bonus.name}统计`,
      type: 'bonus',
      id: bonus._id
    }))
  }, [])
  const upateCouponStatus = async (bonus) => {
    const status = bonus.status == 1 ? 0 : 1
    await apis.updateBonusCouponStatus(bonus._id, status)
    fetch(query)
  }
  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...query,
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    window.scrollTop = 0
    fetch(nextQuery)
  })

  const columns = getColumns({ fetch, showCouponStatsDialog, upateCouponStatus })

  useMount(() => {
    fetch(query)
  })

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>奖金券管理</Breadcrumb.Item>
          <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
        <Button size="small" onClick={showInfoDialog('添加奖金券')}>添加奖金券</Button>
      </div>
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={bonusCoupons.toJS()}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
      <BonusCouponDialog type="manager" />
    </div>
  )
}

export default withQuery(BonusCouponList)
